module.exports = __webpack_public_path__ + "img/1F1F5-1F1F2.f8e2298d.svg";